import style from './ErrorsComponent.module.scss'

interface IProps {
    errors: string[]
}

export const ErrorsComponent = (props: IProps) => {
    const { errors } = props
    return (
        <div className={style.container}>
            {errors.map((error, idx) => (
                <div key={idx} className={style.errorWrapper}>
                    <span>{error}</span>
                </div>
            ))}
        </div>
    )
}
